// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1m3b8","title":"AfterBackImages_title__2xoVl","images":"AfterBackImages_images__1A_9h"};